/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Box rooms callable wrappers.
 */

import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "../store/firebaseApp";
import type {
  SaveBoxRoomsRequest,
  SaveBoxRoomsResponse,
  RemoveBoxRoomRequest,
  RemoveBoxRoomResponse,
} from "@lemonadetraining/contracts";

// async so a synchronous throw inside httpsCallable still reaches the caller's .catch.
export const saveBoxRooms = async (data: SaveBoxRoomsRequest): Promise<SaveBoxRoomsResponse> => {
  const fn = httpsCallable<SaveBoxRoomsRequest, SaveBoxRoomsResponse>(
    firebaseFunctions,
    "saveBoxRooms"
  );
  return (await fn(data)).data;
};

export const removeBoxRoom = async (data: RemoveBoxRoomRequest): Promise<RemoveBoxRoomResponse> => {
  // The cascade runs up to the function's 300s timeout; the SDK default is 70s.
  const fn = httpsCallable<RemoveBoxRoomRequest, RemoveBoxRoomResponse>(
    firebaseFunctions,
    "removeBoxRoom",
    { timeout: 300000 }
  );
  return (await fn(data)).data;
};
